import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import store from './store'
// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'
// importing the helper
import interceptorsSetup from './helpers/interceptors'
import Cookies from 'js-cookie';
import VueSweetalert2 from 'vue-sweetalert2';
import 'vue-datetime/dist/vue-datetime.css'
import Datetime from 'vue-datetime'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

// and running it somewhere here
interceptorsSetup();

// router setup
import routes from './routes/routes'
// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(Cookies);
Vue.use(VueSweetalert2);
Vue.use(Datetime);
Vue.use(moment);
Vue.component('multiselect', Multiselect);

// configure router
const router = new VueRouter({
  mode:'history',
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active'
});

router.beforeEach((to, from, next) => {
    //console.log("router.beforeEach to : ", to);
    //console.log("router.beforeEach from : ", from);
    //console.log("store ", store);
    //console.log("store.state.session ", store.state.session);
    if(to.meta.isAuthRequire){
        if(Cookies.get('token')) {
            document.title = to.meta.title;
            next()
        } else {
            document.title = 'Login';
            next('/login');
        }
    }
    else if(!to.meta.isAuthRequire){
        document.title = to.meta.title;
        if(to.fullPath.indexOf("index.html") >= 0){
            if(!Cookies.get('token')){
                document.title = 'Login';
                next('/login');
            }
            else{
                document.title = 'Admin Panel - Home';
                next('/admin/home');
            }
        }
        if(!Cookies.get('token') || to.matched[0].path === "*") next();
        else{
            document.title = 'Admin Panel - Home';
            next('/admin/home');
        }
    }


    /*if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!auth.loggedIn()) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    } else {
      next() // make sure to always call next()!
    }*/
});

//console.log("routes : ", routes);
//console.log("__dirname : ", __dirname);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});



// WEBPACK FOOTER //
// ./src/main.js